import React from 'react';

import { styled } from '@mui/material/styles';
import { Box, CircularProgress, InputBase, IconButton, InputAdornment } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import SearchIcon from '@mui/icons-material/Search';

import { InfiniteScrollPagination } from 'components/common/InfiniteScrollPagination';
import { Results } from './Results';

import { useSearchProperties } from 'hooks/useSearchProperties';

const SearchWrapper = styled(Box)(({ theme }) => ({
  borderRadius: '24px',
  backgroundColor: theme.palette.secondary.main,
  '&:focus-within': {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  position: 'relative',
  width: 434,
  padding: theme.spacing(1, 2),
  color: theme.palette.secondary.dark,
}));

export const SearchSection = () => {
  const {
    searchValue,
    searchResults,
    searchLoading,
    showResults,
    setShowResults,
    handleSearchChange,
    handleFocus,
    handleBlur,
    handleSelectResult,
    clearSearch,
    fetchNext,
    hasMore,
  } = useSearchProperties();

  return (
    <Box sx={{ position: 'relative', display: 'block' }}>
      <SearchWrapper>
        <StyledInputBase
          value={searchValue}
          onChange={handleSearchChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder="Search"
          inputProps={{ 'aria-label': 'search' }}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end">
              {searchLoading ? (
                <CircularProgress
                  size={18}
                  sx={{ color: '#888' }}
                />
              ) : searchValue ? (
                <IconButton onClick={clearSearch}>
                  <CloseOutlinedIcon fontSize="small" />
                </IconButton>
              ) : null}
            </InputAdornment>
          }
        />
      </SearchWrapper>
      {showResults && (
        <InfiniteScrollPagination
          fetchData={fetchNext}
          isFetching={searchLoading}
          hasMore={hasMore && !searchLoading}
          overrideStyles={{
            position: 'absolute',
            width: '100%',
            maxHeight: 220,
            overflowY: 'auto',
            zIndex: 10,
            marginTop: 3,
            boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.2)',
            borderRadius: 3,
          }}
        >
          <Results
            searchResults={searchResults}
            toggleShowResults={setShowResults}
            onSelectResult={(item) => handleSelectResult(item)}
          />
        </InfiniteScrollPagination>
      )}
    </Box>
  );
};
